import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Mail, Heart, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import ContactForm from './ContactForm';
import { companyInfo } from '../data/mock';

const ContactPage = () => {
  return (
    <section className="form-section py-16 lg:py-24 min-h-screen">
      <Helmet>
        <title>Contact Us - Request Home Care Consultation | A Gentle Touch HomeCare</title>
        <meta name="description" content="Contact A Gentle Touch HomeCare for a free home care consultation in Columbus, Ohio. Call 614-928-4169 or fill out our form. We provide compassionate non medical senior care services." />
        <link rel="canonical" href="https://agentletouchhomecare.com/contact" />
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back to Home Link */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#008080] hover:text-[#006666] mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        {/* Contact Form Card */}
        <div className="form-card">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0, 128, 128, 0.1)' }}>
              <Heart className="w-6 h-6" style={{ color: '#008080' }} />
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-display font-semibold" style={{ color: '#c49bc4' }}>
                Request Care
              </h1>
              <p className="text-gray-500 text-sm">We&apos;ll get back to you shortly</p>
            </div>
          </div>
          
          <div className="mb-6 p-4 rounded-xl" style={{ background: 'rgba(0, 128, 128, 0.05)' }}>
            <p className="text-gray-600 mb-3">
              Contact us today to discuss how we can help your loved one live comfortably and safely at home.
            </p>
          
          </div>
          
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
